import React from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import Accordion from '@vfgroup-oneplatform/foundation/Components/Timeline/Accordion/Accordion';

import RecommendedBadge from '../RecommendedBadge';

import PlanContent from './Components/PlanContent';
import PlanHeader from './Components/PlanHeader';
import styles from './PlanAccordion.Styles';

const PlanAccordion = ({
  images,
  activeSections,
  sections,
  withChoosePlan,
  withWhyThisPlan,
  onWhyThisPlanPress,
  onSelectPlanPress,
  sectionContainerStyle,
  recommendForYouKey,
  freeSubscriptionsKey,
  whyThisPlanKey,
  choosePlanKey,
  whyThisPlanStyle,
  choosePlanButtonType,
  planNameTextStyle,
  choosePlanButtonTextStyle,
  featureTextStyle,
  subscriptionsTextStyle,
  planTitleNumberOfLines,
  isCurrencyFirst,
  ...props
}) => {
  const theme = useTheme();
  return (
    <Accordion
      renderSectionContainerStyle={(conent, index) => {
        return {
          ...styles.sectionContainerStyle(sections[index]?.isRecommended, theme),
          ...sectionContainerStyle,
        };
      }}
      activeSections={activeSections}
      underlayColor={null}
      sections={sections}
      renderHeader={(plan, index) => (
        <>
          {sections[index]?.isRecommended ? (
            <RecommendedBadge
              i18nKey={recommendForYouKey}
              containerStyle={styles.recommendedBadageContainer}
            />
          ) : undefined}
          <PlanHeader
            index={index}
            plan={plan}
            isRecommended={sections[index]?.isRecommended}
            isActive={activeSections.includes(index)}
            planNameTextStyle={planNameTextStyle}
            numberOfLines={planTitleNumberOfLines}
            isCurrencyFirst={isCurrencyFirst}
          />
        </>
      )}
      renderContent={(content, index) => {
        return (
          <PlanContent
            index={index}
            withChoosePlan={withChoosePlan}
            withWhyThisPlan={sections[index].withWhyThisPlan}
            onWhyThisPlanPress={onWhyThisPlanPress}
            onSelectPlanPress={() => onSelectPlanPress(sections[index])}
            features={sections[index].features}
            images={images}
            subscriptions={sections[index].subscriptions}
            freeSubscriptionsKey={freeSubscriptionsKey}
            whyThisPlanKey={whyThisPlanKey}
            choosePlanKey={choosePlanKey}
            whyThisPlanStyle={whyThisPlanStyle}
            choosePlanButtonType={choosePlanButtonType}
            choosePlanButtonTextStyle={choosePlanButtonTextStyle}
            featureTextStyle={featureTextStyle}
            subscriptionsTextStyle={subscriptionsTextStyle}
          />
        );
      }}
      expandMultiple
      {...props}
    />
  );
};

PlanAccordion.defaultProps = {
  activeSections: [],
  sections: [],
  onSectionContainerLayout: () => {},
  isCurrencyFirst: false,
};
PlanAccordion.propTypes = {
  recommendForYouKey: PropTypes.string,
  whyThisPlanKey: PropTypes.string,
  choosePlanKey: PropTypes.string,
  freeSubscriptionsKey: PropTypes.string,
  activeSections: PropTypes.array,
  sections: PropTypes.array,
  withChoosePlan: PropTypes.bool,
  withWhyThisPlan: PropTypes.bool,
  onSelectPlanPress: PropTypes.func,
  sectionContainerStyle: ViewPropTypes.style,
  onSectionContainerLayout: PropTypes.func,
  onWhyThisPlanPress: PropTypes.func,
  whyThisPlanStyle: PropTypes.object,
  choosePlanButtonType: PropTypes.string,
  planNameTextStyle: PropTypes.object,
  choosePlanButtonTextStyle: PropTypes.object,
  featureTextStyle: PropTypes.object,
  subscriptionsTextStyle: PropTypes.object,
  planTitleNumberOfLines: PropTypes.number,
  isCurrencyFirst: PropTypes.bool,
  images: PropTypes.object,
};

export default PlanAccordion;
